import { render, staticRenderFns } from "./DailyChallengeProblem.vue?vue&type=template&id=ddc452c4&scoped=true&"
import script from "./DailyChallengeProblem.vue?vue&type=script&lang=ts&"
export * from "./DailyChallengeProblem.vue?vue&type=script&lang=ts&"
import style0 from "./DailyChallengeProblem.vue?vue&type=style&index=0&id=ddc452c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc452c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ddc452c4', component.options)
    } else {
      api.reload('ddc452c4', component.options)
    }
    module.hot.accept("./DailyChallengeProblem.vue?vue&type=template&id=ddc452c4&scoped=true&", function () {
      api.rerender('ddc452c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/dailyproblems/components/DailyChallengeProblem.vue"
export default component.exports